import React, { Fragment, useEffect, useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import DataTable from "../../DataTable/DataTable";
import { Button } from "@material-ui/core";
import { CreateNewSerialCodeActions } from "../../../Actions/AuditActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loading from "../../Loading/Loading";

const HEADER_ARR = [
  "New Serial Codes",
  "Date",
  "Generated by",
  <>
    Label Download <br />
    Status
  </>,
  "Action",
];

const PreviouslyCreatedSerialCode = ({
  close,
  previously__scanned__code,
  code,
  handleForcedCreate,
  handleDownloadLabel,
}) => {
  const dispatch = useDispatch();

  //   Create New Serial Code state
  const { NewSerial_code, loading: serial__code__loading } = useSelector(
    (state) => state.NewSerialCodes
  );

  const [isForced, setIsForced] = useState(false);

  const handleForceCreation = () => {
    setIsForced(true);
    dispatch(CreateNewSerialCodeActions("create_new_serial_code", code, true));
  };

  // console.log("NEW SERIAL CODE: ", NewSerial_code);

  useEffect(() => {
    if (NewSerial_code && NewSerial_code?.status === 1 && isForced) {
      toast.success(NewSerial_code && NewSerial_code?.msg);
      setIsForced(false);
      close();
      handleForcedCreate(
        NewSerial_code?.data,
        NewSerial_code?.data?.code,
        NewSerial_code?.data?.bbsc_id
      );
    }
    if (NewSerial_code && NewSerial_code?.status === 0 && isForced) {
      toast.error(NewSerial_code && NewSerial_code?.msg);
      setIsForced(false);
    }
    // eslint-disable-next-line
  }, [NewSerial_code, isForced, handleForcedCreate]);

  return (
    <>
      <HeadingTitle
        title={"Previous Serial Code"}
        center={false}
        closeModal={close}
      />
      <div className="previously_scanned__serial_code">
        <p>The previous serial code was generated based on this serial code.</p>

        {/* DataTable Component starts here */}
        <div className="table-wrapper-pagination">
          <div className="table-container-pagination">
            {/* {loading || changeInspectionLoading ? (
              <Loading
                loading={loading}
                color={"rgba(1, 18, 34, 1)"}
                size={42}
              />
            ) : ( */}
            <Fragment>
              <DataTable
                header={HEADER_ARR}
                handleDownloadLabel={handleDownloadLabel}
                PreviousSerial_Data={previously__scanned__code || []}
              />
            </Fragment>
            {/* )} */}
          </div>
        </div>
        {/* DataTable Component ends here */}

        <div className="proceed__container">
          <h4>Do you want to proceed?</h4>
          <div>
            <div>
              <Button className="red_cta" onClick={handleForceCreation}>
                {serial__code__loading ? (
                  <Loading
                    loading={serial__code__loading}
                    color={"#1c1c1c"}
                    size={18}
                  />
                ) : (
                  "Yes"
                )}
              </Button>
            </div>
            <div>
              <Button className="green_cta" onClick={close}>
                No
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviouslyCreatedSerialCode;
